import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class DailySlotService {
  public customer: CustomerModel;

  constructor(
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    private config: ConfigService,
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    )
  }

  getUrl(numSpins): string {
    const config = this.config.getConfig();
    const html5Url = config.HTML5_BASEURL;
    const webserviceUrl = this.config.getEnv().webservices_url;
    const params = new URLSearchParams();
    const cacheBuster = new Date().getTime();
    params.set('appBaseUrl', (webserviceUrl).toString());
    params.set('htmlBaseURL', html5Url);
    params.set('customer_id', (this.customer.customerId).toString());
    params.set('session_token', this.userSession.getSessionToken());
    params.set('code', "ELIGIBLE");
    params.set('numSpins', numSpins);
    params.set('cacheBuster', `${cacheBuster}`);

    if (config.FEATURE_SITE_TERMS_LINK) params.set('termsURL', config.FEATURE_SITE_TERMS_LINK);

    const dailyslot_skin =  config.SITE_DAILY_SLOT_SKIN ?? 'mohegansun';

    const iframeUrl: any = `${html5Url}/dailyslot/web/${dailyslot_skin}/index.html?` + params.toString() + `&v=${cacheBuster}`;
    return iframeUrl;
  }
}
